<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    
    import MilkOption from "./Milkoption.svelte";
    
    export let milkTypeOfSchool;
    export let week;
    export let userSelectionOrderWeek;
    
    import milkOptionsStore from "../../stores/milkOptions-store.js";
    $: availableMilkOptions = $milkOptionsStore;
    $: milkOptions = availableMilkOptions[milkTypeOfSchool];

    function handleSelection(milkoptionCode) {
        dispatch("newSelection", {
          weekNo: week.weekNo,
          selection: milkoptionCode
        });
    }

    function handleRemoving() {
        dispatch("newSelection", {
          weekNo: week.weekNo,
          selection: null
        });
    }

    function getNiceDate(timestamp) {
      let myDate = new Date(1000 * timestamp);
      let dateString = "";
      dateString += myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate();
      dateString += ".";
      dateString += (myDate.getMonth() + 1) < 10 ? "0" + (myDate.getMonth() + 1) : (myDate.getMonth() + 1);
      dateString += ".";
      return dateString;
    }
</script>

<div class:active={userSelectionOrderWeek != null && typeof userSelectionOrderWeek != "undefined"} class="weekContainer animate__fadeInUp animate__animated">
  <div class="weekInfo">
    <p class="weekNo">KW {week.weekNo < 10 ? "0" + week.weekNo : week.weekNo}</p>
    <p class="weekDate">{getNiceDate(week.dateBegin)} - {getNiceDate(week.dateEnd)}</p>
    <p class="weekSchooldays">{week.adjustedSchoolDays} Schultage</p>
  </div>
  <div class="milkOptions">
    {#each milkOptions.options as milkDetails, i}
        <MilkOption on:selected={() => handleSelection(milkDetails.code)} on:removed={handleRemoving} {milkDetails} schooldays={week.adjustedSchoolDays} isActive={userSelectionOrderWeek == milkDetails.code}/>
    {/each}
  </div>
</div>

<style>
  .weekContainer:nth-child(2) { animation-delay: .15s }
  .weekContainer:nth-child(3) { animation-delay: 0.3s }
  .weekContainer:nth-child(4) { animation-delay: 0.45s }
  .weekContainer:nth-child(5) { animation-delay: 0.6s }

  .weekContainer {
    margin: 15px 0;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    background-image: url(/assets/img/milkSplashBackgroundGray.svg);
    background-repeat: no-repeat;
    background-position: -50px 0;
    transition: box-shadow 0.25s ease-in-out, transform 0.1s ease-in-out;
  }

  .weekContainer.active {
    background-image: url(/assets/img/milkSplashBackgroundBlue.svg);
  }

  .weekContainer > .weekInfo {
    cursor: default;
    color: #676767;
    text-align: left;
    line-height: 22px;
    padding: 20px;
    transition: color 0.1s ease-in-out;
  }

  .weekContainer.active > .weekInfo {
    color: #fff;
  }

  .weekInfo {
    min-width: 115px;
  }

  .weekInfo > p {
    margin-bottom: 0;
  }
  .weekInfo > p.weekNo {
    font-size: 28px;
    font-weight: bolder;
  }
  .weekInfo > p.weekDate {
    font-size: 15px;
  }
  .weekInfo > p.weekSchooldays {
    font-size: 13px;
    text-align: right;
  }

  .milkOptions {
    flex-grow: 4;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 110px;
  }

  @media screen and (max-width: 1400px) {
    .weekContainer {
      background-image: none !important;
    }
    .weekContainer > .weekInfo {
      color: #676767 !important;
    }
  }

  @media screen and (max-width: 500px) {
    .milkOptions {
      margin-left: 0;
    }
  }
</style>
